import Joi from "joi";

export const planSchema = Joi.object({
  sName: Joi.string().trim().required().messages({
    "string.empty": "Plan Name is required",
    "string.base": "Plan Name is must be a string",
  }),

  sDescription: Joi.string().trim().required().messages({
    "string.base": "Description must be a string",
    "string.empty": "Description is required",
  }),

  dPrice: Joi.number().positive().required().messages({
    "number.base": "Price must be a number",
    "number.positive": "Price must be greater than zero",
    "any.required": "Price is required",
  }),

  features: Joi.array().items(Joi.string()).min(1).required().messages({
    "array.base": "At least one feature is required",
    "array.min": "At least one feature is required",
    "any.required": "At least one feature is required",
  }),
});
